import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { usePacienteLaboratorio } from '../hooks/usePacienteLaboratorio';

import { Error, Forbidden, Loader, ModalContainer, MultiTextInputPreview, PrimaryButton, TextInputPreview } from '../../../components';
import { DetalleLabRadModal } from '../../Modals/DetalleLabRad';

import styles from '../PacienteConsulta.module.css';

export const LaboratorioPrevio = ({ id, editar, setLaboratorioActual }) => {

  const { permisos } = useSelector(state => state.auth);

  const { pacienteLaboratorioQuery: { isLoading, isError, data: laboratorios } } = usePacienteLaboratorio(id);

  const [laboratorioActivo, setLaboratorioActivo] = useState(null);

  const [statusDetallesModal, setStatusDetallesModal] = useState(false);

  const showDetallesModal = () => {
    setStatusDetallesModal(true);
  }

  const hideDetallesModal = () => {
    setStatusDetallesModal(false);
  }

  const handleDetalles = (lab) => {
    setLaboratorioActivo(lab);
    showDetallesModal();
  }

  const handleEditar = (lab) => {
    setLaboratorioActual(lab);
    editar();
  }
  
  return (permisos.laboratorioRead || permisos.laboratorioUpdate) ? (
    <>
    {(isLoading)
      ? <Loader />
      : <>
          {(isError)
            ? <Error />
            : <>
              {laboratorios.map((lab, index) => <div key={lab._id}>
                <div className="row">
                  <div className="col">
                    <TextInputPreview
                        label="Fecha"
                        name="fecha"
                        value={lab.fechaFormato}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <MultiTextInputPreview
                      borders={false}
                      label="Estudios"
                      name="estudios"
                      values={lab.estudios}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <TextInputPreview
                        label="Comentarios"
                        marginBottom={false}
                        name="cometarios"
                        value={(lab.comentarios !== '') ? lab.comentarios : '-'}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col">
                        <PrimaryButton
                          block={true}
                          inverse={true}
                          marginTop={false}
                          onClick={() => handleDetalles(lab)}
                          text='Ver Detalles'
                          type='button'
                        />
                      </div>
                      <div className="col">
                        <PrimaryButton
                          block={true}
                          marginTop={false}
                          onClick={() => handleEditar(lab)}
                          text='Editar'
                          type='button'
                          />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.hrLabRad}></div>
              </div>)}
              <ModalContainer
                state={ statusDetallesModal }
                hide={ hideDetallesModal }
                content={ <DetalleLabRadModal hide={ hideDetallesModal } data={(laboratorioActivo !== null) ? laboratorioActivo : {}} /> }
              />
            </>
          }
      </>
    }
    </>
  ) : <div><Forbidden /></div>
}

LaboratorioPrevio.propTypes = {
  id: PropTypes.string.isRequired,
  editar: PropTypes.func.isRequired,
  setLaboratorioActual: PropTypes.func.isRequired,
}